// Import React and Hooks
import React from 'react'
// Import Redux and Hooks
import { Dispatch } from 'redux'
import { useAppDispatch, useAppSelector } from '../../hooks/useRedux'
// Import Actions
import { closeModalAction } from '../../actions/modalAction'
// Import Components
import ModalMessage from '../ui/ModalMessage'
import ModalSuccess from '../ui/ModalSuccess'
import ModalOffering from '../ui/ModalOffering'



const Modal = () => {



  // Use Dispatch
  const dispatch:Dispatch<any> = useAppDispatch()



  // Use selector
  const modal = useAppSelector( state => state.modal )



  // Destructuring
  const { isOpen, modalTypes } = modal



  // Functions
  function renderModalClose( hasClose:boolean ) {
    return hasClose && <span
      onClick={ closeModal }
      className="modal__close" />
  }

  function renderModal( modalItem:any ) {
    switch (modalItem.id) {
      case 'message':
        return <ModalMessage dataModalMessage={ modalItem } />
      case 'success':
        let menu1 = document.querySelector('main[role="main"]');
        {menu1?.classList.contains('zIndex') ? menu1?.classList.remove('zIndex') : menu1?.classList.add('zIndex')}
        return <ModalSuccess dataModalSuccess={ modalItem } />
      case 'offering':
        let menu = document.querySelector('main[role="main"]');
        {menu?.classList.contains('zIndex') ? menu?.classList.remove('zIndex') : menu?.classList.add('zIndex')}
        return <ModalOffering dataModalOffering={ modalItem } />
      default:
        return <p> ERROR </p>
    }
  }



  // Functions
  function closeModal() {
    dispatch( closeModalAction() )
  }



  return (
    <section className={`modal ${ !isOpen ? 'hide' : '' }`}>
      <div className="modal__wrapper">
        <div className="modal__container">
          { modalTypes.length > 0 && modalTypes.map( modalItem => {
            if( modalItem.isVisible ) {
              return <>
                { renderModalClose( modalItem.hasClose ) }
                { renderModal( modalItem ) }
              </>
            }
          } ) }
        </div>
      </div>
    </section>
  )
}



export default Modal
